// @flow
import { PROP_US_CUSTOMARY, PROP_METRIC } from 'fc-model-users'

export const TREE = 'accountsModule'

export const ADD_ACCOUNT = '@accountsModule/ADD_ACCOUNT'
export const UPDATE_ACCOUNT_OPERATION = '@accountsModule/UPDATE_ACCOUNT_OPERATION'
export const USER_EMAIL_EXISTS_REGEX = /^userWithEmail\w.+AlreadyExists$/
export const USER_USERNAME_EXISTS_REGEX = /^user.+AlreadyExists$/
export const DEFAULT_UNITS_OPTS = [
  {
    value: PROP_US_CUSTOMARY,
    label: 'US Customary',
  },
  {
    value: PROP_METRIC,
    label: 'Metric',
  },
]

export const PASSWORD_VALIDATION = {
  length: 'At least eight characters.',
  specialChar: 'At least one special character.',
  uppercase: 'At least one uppercase letter.',
  lowercase: 'At least one lowercase letter.',
  number: 'At least one number.',
  containsPersonalInfo: 'Cannot contain the first name, last name, username & email.',
  passwordMatch: 'Password and Confirm password should be same.',
  identicalChars: 'Cannot contain more than two identical characters in a row.',
}

export const PASSWORD_VALIDATION_ERR_CHECKS = {
  length: false,
  specialChar: false,
  uppercase: false,
  lowercase: false,
  number: false,
  containsPersonalInfo: false,
  identicalChars: false,
}

export const PASSWORD_VALIDATION_REGEX = {
  specialChar: /[^a-zA-Z0-9]/,
  uppercase: /[A-Z]/,
  lowercase: /[a-z]/,
  number: /[0-9]/,
}

export const PASSWORD_LENGTH = 8
